import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class PlatformDetectionService {
  constructor(private platform: Platform) {}

  /**
   * Check if the app is running on web platform
   */
  isWeb(): boolean {
    return Capacitor.getPlatform() === 'web';
  }

  /**
   * Check if the app is running on mobile (iOS or Android)
   */
  isMobile(): boolean {
    return Capacitor.isNativePlatform();
  }

  /**
   * Check if the app is running on Android
   */
  isAndroid(): boolean {
    return Capacitor.getPlatform() === 'android';
  }

  /**
   * Check if the app is running on iOS
   */
  isIOS(): boolean {
    return Capacitor.getPlatform() === 'ios';
  }

  /**
   * Get the current platform name
   */
  getPlatform(): string {
    return Capacitor.getPlatform();
  }

  /**
   * Check if running in hybrid mode (Capacitor with native features)
   */
  isHybrid(): boolean {
    return this.platform.is('hybrid');
  }

  /**
   * Check if a specific Capacitor plugin is available
   */
  isPluginAvailable(pluginName: string): boolean {
    return Capacitor.isPluginAvailable(pluginName);
  }
}
